// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"af2983ab","500":"6b88bf54","952":"807db884"}[chunkId] + ".chunk.js";
};